import React from 'react';
import cn from 'classnames';

import styles from './ParkingSlot.module.scss';

import asset from './asset'
import Layouttooltip  from './Layouttooltip';

export default function ParkingSlot(props) {
 
  var elements = []
  var cnt = 0;
  props.parkingSlots.forEach(function (elem) {
    cnt++;
    elements.push(
      <div key={5000 + elem.key} className={cn(styles.slot_block, styles.slot_block_layout)}>
        {
          elem.leftStatus === 'Available' ?
          <Layouttooltip rightName={elem.leftName} status={elem.leftStatus} position={'leftPositon'}>  <img key={elem.key} src={asset[elem.leftSlot]} alt={elem.leftSlot} className={cn(styles.parking_slot_left_img, styles.parking_slot_left_img_layout)} /></Layouttooltip>
            : elem.leftStatus === 'portError' ?
            <Layouttooltip  rightName={elem.leftName} status={elem.leftStatus} position={'leftPositon'}> <img key={elem.key} src={asset[elem.leftSlot]} alt={elem.leftSlot} className={cn(styles.parking_slot_left_img, styles.parking_slot_left_img_layout)} /></Layouttooltip> 
           :
           <Layouttooltip rightName={elem.leftName} status={elem.leftStatus} position={'leftPositon'}>  <img key={elem.key} src={asset[elem.leftSlot]} alt={elem.leftSlot} className={cn(styles.parking_slot_left_img, styles.parking_slot_left_img_layout)} /></Layouttooltip> 
        }
        {
          elem.rightStatus === 'portError' ?
          <Layouttooltip rightName={elem.rightName} status={elem.rightStatus} position={'rightPosition'}> <img key={100 + elem.key} src={asset[elem.rightSlot]} alt={elem.rightSlot} className={cn(styles.parking_slot_right_img, styles.parking_slot_right_img_layout)} /></Layouttooltip> 
            : elem.rightStatus === 'Available' ?
            <Layouttooltip rightName={elem.rightName} status={elem.rightStatus} position={'rightPosition'}> <img key={100 + elem.key} src={asset[elem.rightSlot]} alt={elem.rightSlot} className={cn(styles.parking_slot_right_img, styles.parking_slot_right_img_layout)} /></Layouttooltip> 
            :
            <Layouttooltip  rightName={elem.rightName} status={elem.rightStatus} position={'rightPosition'}> <img key={100 + elem.key} src={asset[elem.rightSlot]} alt={elem.rightSlot} className={cn(styles.parking_slot_right_img, styles.parking_slot_right_img_layout)} /></Layouttooltip> 
        }
       
        

        {
          elem.rightStatus === 'charging' ?
            <img key={200 + elem.key} src={asset[elem.rightIcon]} alt={elem.rightIcon} className={cn(styles.parking_slot_right_ic, styles.parking_slot_right_ic_layout)} />
            : elem.rightStatus === 'v2g' ?
              <img key={300 + elem.key} src={asset[elem.rightIcon]} alt={elem.rightIcon} className={cn(styles.parking_slot_right_ic, styles.parking_slot_right_ic_layout)} />
              : elem.rightStatus === 'plugged' ?
                <img key={400 + elem.key} src={asset[elem.rightIcon]} alt={elem.rightIcon} className={cn(styles.parking_slot_right_ic, styles.parking_slot_right_ic_layout)} />
                : elem.rightStatus === 'offine' ?
                  <img key={500 + elem.key} src={asset[elem.rightIcon]} alt={elem.rightIcon} className={cn(styles.parking_slot_right_ic, styles.parking_slot_right_ic_layout)} />
                  : elem.rightStatus === 'error' ?
                    <img key={600 + elem.key} src={asset[elem.rightIcon]} alt={elem.rightIcon} className={cn(styles.parking_slot_right_ic, styles.parking_slot_right_ic_layout)} />
                    :
                    ''
                    // <img key={200 + elem.key} src={asset[elem.rightIcon]} alt={elem.rightIcon} className={cn(styles.parking_slot_right_ic, styles.parking_slot_right_ic_layout)} />

        }
        {
          elem.leftStatus === 'charging' ?
            <img key={700 + elem.key} src={asset[elem.leftIcon]} alt={elem.leftIcon} className={cn(styles.parking_slot_left_ic, styles.parking_slot_left_ic_layout)} />
            : elem.leftStatus === 'v2g' ?
              <img key={800 + elem.key} src={asset[elem.leftIcon]} alt={elem.leftIcon} className={cn(styles.parking_slot_left_ic, styles.parking_slot_left_ic_layout)} />
              : elem.leftStatus === 'plugged' ?
                <img key={900 + elem.key} src={asset[elem.leftIcon]} alt={elem.leftIcon} className={cn(styles.parking_slot_left_ic, styles.parking_slot_left_ic_layout)} />
                : elem.leftStatus === 'offine' ?
                  <img key={110 + elem.key} src={asset[elem.leftIcon]} alt={elem.leftIcon} className={cn(styles.parking_slot_left_ic, styles.parking_slot_left_ic_layout)} />
                  : elem.leftStatus === 'error' ?
                    <img key={20 + elem.key} src={asset[elem.leftIcon]} alt={elem.leftIcon} className={cn(styles.parking_slot_left_ic, styles.parking_slot_left_ic_layout)} />
                    :
                    ''
                    // <img key={300 + elem.key} src={asset[elem.leftIcon]} alt={elem.leftIcon} className={cn(styles.parking_slot_left_ic, styles.parking_slot_left_ic_layout)} />

        }

        <div className={cn(styles.pipe_block, styles.pipe_block_layout)}>
          <div key={elem.key} className={cn(styles.pipe_border_block, styles.pipe_border_block_layout)}>
            <div className={cn(styles.pipe_border_group, styles.pipe_border_group_layout)}>
              <div className={cn(styles.pipe_border_horizontal_box, styles.pipe_border_horizontal_box_layout)} />
              <div className={cn(styles.pipe_border_vertical_box, styles.pipe_border_vertical_box_layout)} />
            </div>
          </div>

          <div className={cn(styles.pipe_borderLess_block, styles.pipe_borderLess_block_layout)}>
            <div className={cn(styles.pipe_borderLess_group, styles.pipe_borderLess_group_layout)}>
              <div className={cn(styles.pipe_borderLess_vertical_boxbox, styles.pipe_borderLess_vertical_boxbox_layout)} />
              <div className={cn(styles.pipe_borderLess_horizontal_boxbox, styles.pipe_borderLess_horizontal_boxbox_layout)} />
            </div>
          </div>
        </div>
      </div>
    );
  });
  return (
    <div>
      {elements}
    </div>
  );
}
